import Vue from 'vue';
import Vuex from 'vuex';

import NewVehicleData from './modules/new-vehicle-data.js';
import CustomerData from './modules/customer-data.js';
// import FinanceParameters from './modules/finance-parameters.js';
import Finance from './modules/finance.js';
import Layout from './modules/layout.js';
import RepresentativeExample from './modules/representative-example.js';
import Valuations from './modules/valuations.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        NewVehicleData,
        CustomerData,
        // FinanceParameters,
        Finance,
        Layout,
        RepresentativeExample,
        Valuations,
    },
    strict: debug,
});


// WEBPACK FOOTER //
// ./resources/assets/js/new-vue/store/index.js